let INITIAL_THEME = window.INITIAL_THEME;
let ICONS_BASEURL = window.ICONS_BASEURL;
let CSS_URL = window.CSS_URL;
let BASE_URL = window.BASE_URL;
let Env = window.SPACES_PARAMS;

export default SPACES_PARAMS;
export { INITIAL_THEME, ICONS_BASEURL, CSS_URL, BASE_URL, Env };
